// Formats a folder's grade value for display.
// Grades are stored as strings: "K" for Kindergarten or "1".."12".
export function formatGrade(grade) {
  if (!grade) return null;
  if (grade === 'K') return 'Kindergarten';
  return `Grade ${grade}`;
}
